exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container__3totV{padding:1rem 0}.listContainer__24n7Y{margin-top:0}", "", {"version":3,"sources":["/opt/build/repo/src/components/contact-list/styles.scss"],"names":[],"mappings":"AAAA,kBACE,cAAe,CAChB,sBAGC,YAAgB,CACjB","file":"styles.scss","sourcesContent":[".container {\n  padding: 1rem 0;\n}\n\n.listContainer {\n  margin-top: 0rem;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__3totV",
	"listContainer": "listContainer__24n7Y"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/contact-list/styles.scss
// module id = zm24
// module chunks = 0